var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"admin-app"},[_c(_vm.getThemeMode.layout,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }